<template>
  <div id="domain-create" class="row">
    <form id="create-domain-form" class="small-12 medium-5 columns" @submit.prevent="submitForm">
      <label>
        {{ 'Domain'|t }}
        <input type="text" ref="domain" v-model="domain" :placeholder="'Domain'|t" required="required" autofocus />
      </label>

      <label>
        {{ 'Period'|t }}
        <input type="number" min="1" max="10" value="1" v-model="period" :placeholder="'Years'|t" required="required" />
      </label>

      <label>
        {{ 'Name servers'|t }}
        <textarea v-model="ns" rows="5" :placeholder="'One name server per line.'|t"></textarea>
      </label>

      <fieldset class="fieldset">
        <legend>{{ 'Contacts'|t }}</legend>
        <label>
          {{ 'Registrant'|t }}
          <input type="text" v-model="registrant" :placeholder="'Registrant'|t" required="required" />
        </label>

        <label>
          {{ 'Admin contact'|t }}
          <input type="text" v-model="admin" :placeholder="'Admin'|t" required="required" />
        </label>

        <label>
          {{ 'Tech contact'|t }}
          <input type="text" v-model="tech" :placeholder="'Tech'|t" required="required" />
        </label>

        <label>
          {{ 'Billing contact'|t }}
          <input type="text" v-model="billing" :placeholder="'Billing'|t" required="required" />
        </label>
      </fieldset>

      <label>
        {{ 'Authentication password'|t }}
        <input type="text" v-model="auth" :placeholder="'Authentication password'|t" required="required" />
      </label>

      <fieldset class="fieldset">
        <legend> {{ 'DNSSEC Mapping'|t }}</legend>

        <table v-for="(rec, k) in dns" class="unstriped">
          <tbody>
          <tr>
            <td>DS Key Tag <a href="https://tools.ietf.org/html/rfc4034#section-5.1.1" target="_blank"><i class="icon icon-info"></i></a></td>
            <td>
              <input v-model="dns[k].ds_keytag" type="number" min="0" max="256" />
            </td>
          </tr>
          <tr>
            <td>DS Digest <a href="https://tools.ietf.org/html/rfc4034#section-5.1.4" target="_blank"><i class="icon icon-info"></i></a></td>
            <td>
              <input v-model="dns[k].ds_digest" type="text" pattern=".{40}" />
            </td>
          </tr>
          <tr>
            <td>Key Flags <a href="https://tools.ietf.org/html/rfc4034#section-2.1.1" target="_blank"><i class="icon icon-info"></i></a></td>
            <td>
              <select v-model="dns[k].key_flags">
                <option value="0">0</option>
                <option value="256">256</option>
                <option value="257">257</option>
              </select>
            </td>
          </tr>
          <tr>
            <td>Key Public Key</td>
            <td>
              <textarea v-model="dns[k].key_pubkey"></textarea>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <button @click.prevent.stop="removeDnsRecord(rec._key)" class="expanded alert button"><i class="icon icon-bin"></i> {{ 'Remove'|t }}</button>
            </td>
          </tr>
          </tbody>
        </table>

        <button @click.prevent.stop="addDnsRecord" class="button"><i class="icon icon-plus"></i> {{ 'Add record'|t }}</button>

        <ul class="help-text">
          <li>
            The record can be one of two types: <strong>dsData</strong> or <strong>keyData</strong>.
          </li>
          <li>
            Multiple records can be provided but they all have to be of the same type.
          </li>
          <li>
            The <strong>dsData</strong> record can hold <strong>keyData</strong> record.
          </li>
          <li>
            If you fill in the <strong>digest</strong> value, the record will be considered <strong>dsData</strong> type.
          </li>
          <li>
            If you fill in the <strong>public key</strong> field, the record will be considered <strong>keyData</strong>.
          </li>
          <li>
            If you fill in <strong>digest</strong> and <strong>public key</strong> the record will be considered <strong>dsData</strong> type with <strong>keyData</strong> child.
          </li>
        </ul>

      </fieldset>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'CreateForm',
    data() {
      return {
        domain: "",
        period: 1,
        ns: "",
        registrant: "",
        admin: "",
        tech: "",
        billing: "",
        auth: "",
        dns: [],
      }
    },
    methods: {
      submitForm() {
        let request = {
          domain: this.domain,
          period: parseInt(this.period),
          nameservers: this.ns.split("\n").filter(word => word.length > 0),
          registrant: this.registrant,
          contact_admin: this.admin,
          contact_tech: this.tech,
          contact_billing: this.billing,
          authinfo: this.auth,
          dnskeys: [],
        };

        let dnsRecords = JSON.parse(JSON.stringify(this.dns));
        for (let i in dnsRecords) {
          let rec = {
            key_flags: dnsRecords[i].key_flags === null ? 0 : parseInt(dnsRecords[i].key_flags),
            key_proto: 3,
            key_alg: 5,
            key_public_key: dnsRecords[i].key_pubkey === null ? "" : String(dnsRecords[i].key_pubkey),
            ds_key_tag: dnsRecords[i].ds_keytag === null ? 0 : parseInt(dnsRecords[i].ds_keytag),
            ds_alg: 5,
            ds_digest_type: 1,
            ds_digest_value: dnsRecords[i].ds_digest === null ? "" : String(dnsRecords[i].ds_digest)
          };

          request.dnskeys.push(rec);
        }

        api.createDomain(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Domain %s has been created.",
              args: [data.domain]
            }, {root: true});
            router.push({name: 'domain.collection'});
          }
        );
      },
      addDnsRecord() {
        this.dns.push({
          _key: Math.random().toString(36).substring(2),
          key_flags: 0,
          key_pubkey: null,
          ds_keytag: null,
          ds_digest: null
        })
      },
      removeDnsRecord(id) {
        for (let k in this.dns) {
          if (this.dns[k]._key === id) {
            this.dns.splice(k, 1);
            return;
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/domain/CreateForm.vue